module.exports = __webpack_public_path__ + "static/media/circle.afb1e3d4.svg";